import React from 'react';
import styles from './styles.module.scss';
import { formatDateTimeByTimestamp } from 'src/utils/date';
import { formatCurrency } from '@wolffun/system-currency';
import { ellipsisMiddle } from 'src/utils/text';
import classNames from 'classnames';

const TableDesktop = ({
  histories
}) => {
  const renderRow = history => /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    key: history.id
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, formatDateTimeByTimestamp(history.timestamp))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tableCell, styles.price)
  }, /*#__PURE__*/React.createElement("span", null, formatCurrency(history.tradeInfo.price, {
    withCurrency: true,
    trimWholeFraction: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, ellipsisMiddle(history.userAddress))), /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, ellipsisMiddle(history.tradeInfo.address))));

  return /*#__PURE__*/React.createElement(React.Fragment, null, histories.map(history => renderRow(history)));
};

export default TableDesktop;